import { useFormik } from 'formik';
import { Box, Button, Stack, Link, TextField, Typography } from '@mui/material';
import { Layout as AuthLayout } from '../../layouts/auth/Layout';
import { ForgotPasswordValidationSchema } from 'utils/validation';
import { sendResetPasswordLink } from 'store/actions/authActions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const auth = useSelector((store: any) => store.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.authInfo.isAuthorized) {
      navigate('/');
    }
  }, [navigate, auth.authInfo?.isAuthorized]);

  const formik = useFormik({
    initialValues: {
      email: '',
      submit: null,
    },
    validationSchema: ForgotPasswordValidationSchema,
    onSubmit: async (values, helpers) => {
      try {
        dispatch(sendResetPasswordLink({ email: values.email }));
      } catch (err: any) {
        helpers.setStatus({ success: false });
        helpers.setErrors({ submit: err.message });
        helpers.setSubmitting(false);
      }
    },
  });

  return (
    <AuthLayout>
      <Box
        sx={{
          backgroundColor: 'background.paper',
          flex: '1 1 auto',
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            maxWidth: 550,
            px: 3,
            py: '100px',
            width: '100%',
          }}
        >
          <div>
            <Stack spacing={1} sx={{ mb: 3 }}>
              <Typography variant='h4'>Forgot password</Typography>
            </Stack>
            <form noValidate onSubmit={formik.handleSubmit}>
              <Stack spacing={3}>
                <TextField
                  error={!!(formik.touched.email && formik.errors.email)}
                  fullWidth
                  helperText={formik.touched.email && formik.errors.email}
                  label='Email Address'
                  name='email'
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  type='email'
                  value={formik.values.email}
                />
              </Stack>
              {formik.errors.submit && (
                <Typography color='error' sx={{ mt: 3 }} variant='body2'>
                  {formik.errors.submit}
                </Typography>
              )}
              <Typography color='text.secondary' variant='body2' mt={1}>
                We’ll send a verification code to this email if it matches an existing BluCloud
                account.
              </Typography>
              <LoadingButton
                disabled={auth.authInfo?.isAPIInProgress}
                loading={auth.authInfo?.isAPIInProgress}
                fullWidth
                size='large'
                sx={{ mt: 3 }}
                type='submit'
                variant='contained'
              >
                Submit
              </LoadingButton>
              <Link width={'100%'} href='/auth/login'>
                <Button fullWidth size='large' sx={{ mt: 3 }} variant='contained'>
                  Back
                </Button>
              </Link>
            </form>
          </div>
        </Box>
      </Box>
    </AuthLayout>
  );
};

export default ForgotPassword;
